import { shallowRef } from 'vue'

interface StartScreenShareParams {
  onEnded?: () => void
}

export function useScreenShareTest() {
  const currentStream = shallowRef<MediaStream>()

  const stopScreenShare = () => {
    if (!currentStream.value) return

    currentStream.value.getTracks().forEach((track) => {
      if (track.readyState !== 'ended') {
        track.stop()
      }
    })
    currentStream.value = undefined
  }

  const startScreenShare = async ({ onEnded }: StartScreenShareParams = {}) => {
    stopScreenShare()

    const stream = await navigator.mediaDevices.getDisplayMedia({
      video: true,
      audio: false
    })

    const [videoTrack] = stream.getVideoTracks()
    if (videoTrack) {
      videoTrack.onended = () => {
        onEnded?.()
        stopScreenShare()
      }
    }

    currentStream.value = stream

    return {
      stream,
      sourceName: videoTrack?.label || '当前共享内容'
    }
  }

  return {
    currentStream,
    startScreenShare,
    stopScreenShare
  }
}
